// extracted by mini-css-extract-plugin
export var contact = "index-module--contact--8d1a7";
export var text = "index-module--text--90dc3";